import { SecondaryData } from '@strata/react-grid';
import { formatRateString, ServicingRate } from '@strata/react-servicing-rate';
import PropTypes from 'prop-types';

/** What each line of a universal assignment's ranked pharmacy list shows */
const RankedPharmaciesContent = {
    names: 'names',
    rates: 'rates',
    namesWithRates: 'namesWithRates',
};

/** One line per pharmacy of a universal assignment, in rank order. */
export const RankedPharmacies = ({ pharmacies, referentPriceType, content }) => (
    <div className="sds_backstop-pharmacy__ranked-list">
        {pharmacies.map((pharmacy, index) => {
            const name = `${index + 1}. ${pharmacy.supplier ?? ''}`;

            if (content === RankedPharmaciesContent.namesWithRates) {
                return (
                    <span
                        key={pharmacy.supplier_npi}
                        className="sds_backstop-pharmacy__ranked-line flex__gap--xx-small"
                    >
                        <span className="sds_backstop-pharmacy__ranked-name">{name}</span>
                        <span>
                            {`(${formatRateString({ bidDecimal: pharmacy.backstop_rate, referentPriceType })})`}
                        </span>
                    </span>
                );
            }

            return (
                <span key={pharmacy.supplier_npi} className="sds_backstop-pharmacy__ranked-line">
                    {content === RankedPharmaciesContent.rates ? (
                        <ServicingRate
                            servicingRate={pharmacy.backstop_rate}
                            referentPriceType={referentPriceType}
                        />
                    ) : (
                        name
                    )}
                </span>
            );
        })}
    </div>
);

RankedPharmacies.propTypes = {
    pharmacies: PropTypes.arrayOf(
        PropTypes.shape({
            supplier_npi: PropTypes.string.isRequired,
            supplier: PropTypes.string,
            backstop_rate: PropTypes.string.isRequired,
        }),
    ).isRequired,
    referentPriceType: PropTypes.string.isRequired,
    content: PropTypes.oneOf(Object.values(RankedPharmaciesContent)).isRequired,
};
RankedPharmacies.Content = RankedPharmaciesContent;

/** Grid cell for a universal assignment; hovering it shows each pharmacy beside its rate. */
export const RankedPharmaciesCell = ({ pharmacies, referentPriceType, content }) => (
    <SecondaryData
        data={
            <RankedPharmacies
                pharmacies={pharmacies}
                referentPriceType={referentPriceType}
                content={content}
            />
        }
        customTooltipContent={
            <RankedPharmacies
                pharmacies={pharmacies}
                referentPriceType={referentPriceType}
                content={RankedPharmaciesContent.namesWithRates}
            />
        }
    />
);

RankedPharmaciesCell.propTypes = {
    pharmacies: PropTypes.arrayOf(
        PropTypes.shape({
            supplier_npi: PropTypes.string.isRequired,
            supplier: PropTypes.string,
            backstop_rate: PropTypes.string.isRequired,
        }),
    ).isRequired,
    referentPriceType: PropTypes.string.isRequired,
    content: PropTypes.oneOf([RankedPharmaciesContent.names, RankedPharmaciesContent.rates])
        .isRequired,
};
RankedPharmaciesCell.Content = RankedPharmaciesContent;
